import styled from "styled-components"
import {TextInputHorizontal} from "@uprise/form"
import {H6} from "@uprise/headings"
import {extended, semantic} from "@uprise/colors"
import {spacing} from "@uprise/spacing"
import {P} from "@uprise/text"

export const HeaderText = styled.label`
	display: flex;
	justify-content: ${props => props.alignText};
`

export const ColumnText = styled(P)`
	display: flex;
	justify-content: ${props => props.textAlign};
	cursor: ${props => (props.link ? "pointer" : null)};
	padding: 6px 0 6px 12px;
	margin: 0;
	font-family: "Proxima Nova";
	font-size: 15px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: normal;
	text-align: left;
`

export const ColumnIcon = styled.div`
	cursor: pointer;
`

export const ColumnContainer = styled.div`
	display: flex;
	justify-content: ${props => props.align};
`
